import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=425c0417&scoped=true&lang=pug&"
import script from "./ModalNotification.vue?vue&type=script&lang=ts&"
export * from "./ModalNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&id=425c0417&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c0417",
  null
  
)

export default component.exports